import React, { useState } from 'react';

const ID = 'checkbox-input';
export interface CheckboxInputProps {
    id?: string;
    onChange?: (value: boolean) => void;
    onFocusChange?: () => void;
    value?: boolean;
    label?: React.ReactNode;
    autoFocus?: boolean;
    disabled?: boolean;
    submitted?: boolean;
    useConditionedStyling?: boolean;
    className?: string;
}

export const CheckboxInput = (props: CheckboxInputProps) => {
    const [internalValue, setInternalValue] = useState<boolean>(props.value || false);

    const isControlled = props.value !== undefined;
    const currentValue = isControlled ? props.value : internalValue;

    const handleChange = () => {
        if (!props.disabled) {
            const newValue = !currentValue;
            if (!isControlled) {
                setInternalValue(newValue);
            }
            props.onChange && props.onChange(newValue);
        }
    };

    return (
        <label
            htmlFor={props.id + ID}
            aria-disabled={props.disabled}
            className={`text-foreground-default !m-0 inline-flex cursor-pointer items-center gap-2 !p-0 !text-sm !leading-none !font-medium !tracking-normal has-[>span>input:disabled]:cursor-not-allowed ${props.className ?? ''}`}>
            <span className='relative inline-flex h-5 w-5 shrink-0 items-center justify-center'>
                <input
                    id={props.id + ID}
                    type='checkbox'
                    checked={currentValue}
                    onChange={handleChange}
                    disabled={props.disabled}
                    autoFocus={props.autoFocus}
                    onFocus={() => {
                        props.onFocusChange && props.onFocusChange();
                    }}
                    className='peer bg-always-white hover:bg-brand-primary/50 border-border-default checked:border-brand-primary checked:bg-brand-primary disabled:bg-background-default h-5 w-5 cursor-pointer appearance-none rounded border shadow transition-all hover:shadow-md disabled:cursor-not-allowed disabled:shadow-none'
                />
                <span className='text-always-white pointer-events-none absolute inset-0 flex items-center justify-center opacity-0 peer-checked:opacity-100'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-3.5 w-3.5'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                        stroke='currentColor'
                        strokeWidth='1'>
                        <path
                            fillRule='evenodd'
                            d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                            clipRule='evenodd'></path>
                    </svg>
                </span>
            </span>
            {props.label && <span className='leading-none'>{props.label}</span>}
        </label>
    );
};
